export default "__VITE_ASSET__3mFSNwdR__"